export default {
  title: '聚展',
  home: '首页',
  logout: '退出',
  login: '登录'
}
